import z, { ZodType } from 'zod';
import { ShiftExtended, shiftExtendedSchema } from './shift-extended';

export type CashdeskTransactionPlayer = {
	id: number;
	balance: number;
	name: string;
};

export const cashdeskTransactionPlayerSchema: ZodType<CashdeskTransactionPlayer> = z.object({
	id: z.number(),
	balance: z.number(),
	name: z.string(),
});

export type CashdeskTransaction = {
	player: CashdeskTransactionPlayer;
	shift: ShiftExtended;
};

export const cashdeskTransactionSchema: ZodType<CashdeskTransaction> = z.object({
	player: cashdeskTransactionPlayerSchema,
	shift: shiftExtendedSchema,
});
